import { ResetPasswordState, RESET_PASSWORD_FEATURE_KEY } from "./reset-password.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const getResetPasswordState = createFeatureSelector<ResetPasswordState>(RESET_PASSWORD_FEATURE_KEY);

export const selectIsLoading = createSelector(getResetPasswordState, (state: ResetPasswordState) => state.loading);

export const selectSucceeded = createSelector(getResetPasswordState, (state: ResetPasswordState) => state.succeeded);

export const selectIsFailure = createSelector(getResetPasswordState, (state: ResetPasswordState) => state.error);